module.exports = __webpack_public_path__ + "static/icon-love.a34ee7f7.svg";